import { CSSProperties } from 'react';
import { RepresentationData } from '@ardoq/data-model';
import { EntityIcon } from './EntityIcon';
import { IconSize } from '@ardoq/icons';
import { representationDataToEntityIconProps } from './utils';

export type ComponentRepresentationProps = RepresentationData & {
  style?: CSSProperties;
  iconSize?: IconSize;
  color?: string;
};

export const ComponentRepresentation = (
  props: ComponentRepresentationProps
) => <EntityIcon {...representationDataToEntityIconProps(props)} />;
